// extracted by mini-css-extract-plugin
export default {"wrapper":"pvjlS","dialog":"M_e6U","navigation":"CX2cD","closeButton":"MeGox","onBoardingCover":"zFinO"};